import firebase from "firebase/app";
import { isNumeric } from "vue-chess-shared/utils/number-helper";

export function cachedTimeOffset() {
  const firestoreTimeOffset = parseFloat(
    sessionStorage.getItem("firestoreTimeOffset")
  );
  if (!isNumeric(firestoreTimeOffset)) return 0;

  return firestoreTimeOffset;
}

export function serverTimestamp() {
  return firebase.firestore.FieldValue.serverTimestamp();
}
